export default __webpack_public_path__ + "659729fe6ed5f8de6048fc6d56275a5b.woff2";